import XHRUpload from '@uppy/xhr-upload';
import authProvider from '@/auth/authProvider';

class XHRAuthUpload extends XHRUpload {
  constructor(uppy, options) {
    super(uppy, options);
    this.id = options.id || 'XHRAuthUpload';
    this.prepareUpload = this.prepareUpload.bind(this);
  }

  async prepareUpload(fileIDs) {
    await authProvider().reauthenticateUser();
    const token = await authProvider().getIdToken();
    fileIDs.forEach((fileID) => {
      const file = this.uppy.getFile(fileID);
      this.uppy.setFileState(file.id, {
        xhrUpload: {
          ...file.xhrUpload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      });
    });
    return Promise.resolve();
  }

  install() {
    super.install();
    this.uppy.addPreProcessor(this.prepareUpload);
  }

  uninstall() {
    super.uninstall();
    this.uppy.removePreProcessor(this.prepareUpload);
  }
}

export default XHRAuthUpload;
